'use client';
import { RemoveScroll } from 'react-remove-scroll';

// src/components/remove-scroll/index.tsx
var remove_scroll_default = RemoveScroll;

export { remove_scroll_default as default };
